import React, { useEffect, useState } from 'react';

import { Button, Dialog, TextInput } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { FILTERS, FILTERS_NAMES } from '../../../../constants/news';
import { sortTagsList } from '../../../../helpers/news';
import { ITagsListOptions } from '../../../../types/tags';
import { Tag } from '../Tag';
import { TagsWrapper } from '../TagsWrapper';

import styles from './tags-modal.module.scss';

interface IProps {
  activeTags: FILTERS[FILTERS_NAMES.TAG];
  isDialogVisible: boolean;
  handleTagChange: (value, label) => void;
  handleModalClose: () => void;
  tagsList: ITagsListOptions;
  modalButtonName: string;
}

export const TagsModal = ({
  activeTags,
  tagsList,
  handleTagChange,
  isDialogVisible,
  handleModalClose,
  modalButtonName,
}: IProps) => {
  const isMobile = useIsMobile();
  const [tagText, setTagText] = useState('');
  const [modalActiveTags, setModalActiveTags] = useState(activeTags);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => activeTags.length !== 0 && setModalActiveTags(activeTags), [...activeTags]);

  const handleClose = () => {
    handleModalClose();
    setTagText('');
  };

  const handleTagSearch = (e) => {
    setTagText(e.target.value);
  };

  const handleModalTagsAdd = (value) => {
    const valueIndex = modalActiveTags.indexOf(value);

    if (valueIndex > -1) {
      const newValue = modalActiveTags;
      newValue.splice(valueIndex, 1);

      setModalActiveTags(() => [...newValue]);
    } else {
      setModalActiveTags((prevState) => [...prevState, value]);
    }
  };

  const handleModalTagsChange = () => {
    handleTagChange(modalActiveTags, null);
    handleClose();
  };

  let tagsOptions = [];

  if (tagText && tagText.length > 1) {
    tagsOptions = tagsOptions.filter(
      (tag) => modalActiveTags.includes(tag.label) || tag.label.toLowerCase().includes(tagText.toLowerCase()),
    );
  }

  if (tagsList.length) {
    tagsOptions = sortTagsList(tagsList, modalActiveTags);
  }

  const handleModalTagsClear = () => setModalActiveTags([]);

  return (
    <Dialog visible={isDialogVisible} onClose={handleClose} fullscreen={isMobile}>
      <Dialog.Header title={'Все темы'} />
      <Dialog.Content className={styles.tagsModalContent}>
        <div className={styles.tagsSearch}>
          <TextInput value={tagText} onChange={handleTagSearch} placeholder={'Поиск темы'} />
        </div>
        <TagsWrapper className={'h-mt-24'}>
          {tagsOptions.map((item) => {
            const active = modalActiveTags.includes(item.label);
            const disabled = !active && modalActiveTags.length > 2;

            return (
              <Tag
                key={`tag-modal-${item.value}`}
                onClick={() => handleModalTagsAdd(item.label)}
                closable={active}
                active={active}
                disabled={disabled}
              >
                {item.label}
              </Tag>
            );
          })}
        </TagsWrapper>
      </Dialog.Content>
      <Dialog.Footer className={styles.tagsModalFooter}>
        <Button
          variant={'text'}
          size={52}
          className={styles.tagsModalButton}
          onClick={handleModalTagsClear}
          name={'Очистить фильтр'}
        >
          Очистить фильтр
        </Button>
        <Button
          onClick={handleModalTagsChange}
          variant={'primary'}
          size={52}
          className={styles.tagsModalButton}
          name={modalButtonName}
        >
          {modalButtonName}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};
